import { render, staticRenderFns } from "./UpdateServiceButton.vue?vue&type=template&id=29552ea8&"
import script from "./UpdateServiceButton.vue?vue&type=script&lang=js&"
export * from "./UpdateServiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports